document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('CustomCartDrawer');
  const closeBtn = document.getElementById('CustomCartDrawerClose');
  const PREMIUM_HANDLE = 'premium-delivery-protection';
  const DISCOUNT_CODE = 'BFCM2025';
  const DISCOUNT_CODE_ENC = encodeURIComponent(DISCOUNT_CODE);


  const UPSELL_RULES = [
  {
    triggers: ['the-basebench', 'basebench-pro'],
    upsell: 'basebands-set',
    desc: '(three pieces)'
  },

  // future:
  // {
  //   triggers: ['product-a'],
  //   upsell: 'upsell-a',
  //   desc: 'Some text'
  // }
];


  /* -------------------------
     AUTO APPLY DISCOUNT CODE
  -------------------------- */
async function autoApplyDiscount() {
  try {
    if (localStorage.getItem('discountApplied') === 'true') return;

    const res = await fetch('/cart.js');
    const cart = await res.json();
    if (cart.item_count === 0) return;

    const hasCode = (cart.discount_codes || []).some(dc =>
      (dc.code || '').toUpperCase() === DISCOUNT_CODE.toUpperCase() && dc.applied !== false
    );

    if (hasCode) {
      localStorage.setItem('discountApplied', 'true');
      return;
    }

    // Apply discount silently — no redirect
    await fetch(`/discount/${DISCOUNT_CODE_ENC}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    });

    // Re-check and update UI
    const updated = await fetch('/cart.js').then(r => r.json());
    const nowHasCode = (updated.discount_codes || []).some(dc =>
      (dc.code || '').toUpperCase() === DISCOUNT_CODE.toUpperCase() && dc.applied !== false
    );

    if (nowHasCode) {
      localStorage.setItem('discountApplied', 'true');
      await loadCartDrawer();
      syncCartBubbles();
    }

  } catch (err) {
    console.error('Error applying discount:', err);
  }
}


  (async function reconcileDiscountFlag() {
    try {
      const flag = localStorage.getItem('discountApplied');
      if (!flag) return;
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const hasCode = (cart.discount_codes || []).some(dc =>
        (dc.code || '').toUpperCase() === DISCOUNT_CODE.toUpperCase() && dc.applied !== false
      );
      localStorage.setItem('discountApplied', hasCode ? 'true' : '');
    } catch {}
  })();

  autoApplyDiscount();

  /* -------------------------
     UTILITY HELPERS
  -------------------------- */
  function toCents(v) {
    if (typeof v === 'number') return Math.round(v);
    if (typeof v === 'string') {
      return v.includes('.') ? Math.round(parseFloat(v) * 100) : parseInt(v, 10) || 0;
    }
    return 0;
  }

  function getCurrency(cart) {
    if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) {
      return Shopify.currency.active;
    }
    if (cart && cart.currency) return cart.currency;
    return 'USD';
  }

  function money(cents, cart = null) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, Shopify.money_format || '${{amount}}');
    }

    const currency = getCurrency(cart);
    const amount = (Math.max(0, cents) / 100).toFixed(2);
    const symbols = { USD: '$', CAD: 'C$', AUD: 'A$', GBP: '£', EUR: '€', NZD: 'NZ$' };
    const symbol = symbols[currency] || '';
    return `${symbol}${amount}`;
  }

  function afterpayLogoSvg() {
  return `
    <svg class="afterpay-logo" xmlns="http://www.w3.org/2000/svg" viewBox="200 150 1200 260" aria-label="Afterpay">
      <g fill="currentColor">
        <path d="M1348.29,209.06l-34.6-19.8-35.1-20.1c-23.2-13.3-52.2,3.4-52.2,30.2v4.5c0,2.5,1.3,4.8,3.5,6l16.3,9.3c4.5,2.6,10.1-.7,10.1-5.9v-10.7c0-5.3,5.7-8.6,10.3-6l32,18.4,31.9,18.3c4.6,2.6,4.6,9.3,0,11.9l-31.9,18.3-32,18.4c-4.6,2.6-10.3-.7-10.3-6v-5.3c0-26.8-29-43.6-52.2-30.2l-35.1,20.1-34.6,19.8c-23.3,13.4-23.3,47.1,0,60.5l34.6,19.8,35.1,20.1c23.2,13.3,52.2-3.4,52.2-30.2v-4.5c0-2.5-1.3-4.8-3.5-6l-16.3-9.3c-4.5-2.6-10.1,.7-10.1,5.9v10.7c0,5.3-5.7,8.6-10.3,6l-32-18.4-31.9-18.3c-4.6-2.6-4.6-9.3,0-11.9l31.9-18.3,32-18.4c4.6-2.6,10.3,.7,10.3,6v5.3c0,26.8,29,43.6,52.2,30.2l35.1-20.1,34.6-19.8c23.3-13.5,23.3-47.1,0-60.5Z"/>
        <path d="M1121.29,215.66l-81,167.3h-33.6l30.3-62.5-47.7-104.8h34.5l30.6,70.2,33.4-70.2h33.5Z"/>
        <path d="M311.39,275.06c0-20-14.5-34-32.3-34s-32.3,14.3-32.3,34,14.5,34,32.3,34,32.3-14,32.3-34M311.69,334.46v-15.4c-8.8,10.7-21.9,17.3-37.5,17.3-32.6,0-57.3-26.1-57.3-61.3s25.7-61.5,58-61.5c15.2,0,28,6.7,36.8,17.1v-15h29.2v118.8h-29.2Z"/>
        <path d="M482.89,308.06c-10.2,0-13.1-3.8-13.1-13.8v-52.7h18.8v-25.9h-18.8v-29h-29.9v29h-38.6v-11.8c0-10,3.8-13.8,14.3-13.8h6.6v-23h-14.4c-24.7,0-36.4,8.1-36.4,32.8v15.9h-16.6v25.8h16.6v92.9h29.9v-92.9h38.6v58.2c0,24.2,9.3,34.7,33.5,34.7h15.4v-26.4h-5.9Z"/>
        <path d="M590.29,264.36c-2.1-15.4-14.7-24.7-29.5-24.7s-26.9,9-29.9,24.7h59.4ZM530.59,282.86c2.1,17.6,14.7,27.6,30.7,27.6,12.6,0,22.3-5.9,28-15.4h30.7c-7.1,25.2-29.7,41.3-59.4,41.3-35.9,0-61.1-25.2-61.1-61.1s26.6-61.8,61.8-61.8,61.1,26.1,61.1,61.8c0,2.6-.2,5.2-.7,7.6h-91.1Z"/>
        <path d="M812.79,275.06c0-19.2-14.5-34-32.3-34s-32.3,14.3-32.3,34,14.5,34,32.3,34,32.3-14.7,32.3-34M718.69,382.96v-167.3h29.2v15.4c8.8-10.9,21.9-17.6,37.5-17.6,32.1,0,57.3,26.4,57.3,61.3s-25.7,61.5-58,61.5c-15,0-27.3-5.9-35.9-15.9v62.5h-30.1v.1Z"/>
        <path d="M947.99,275.06c0-20-14.5-34-32.3-34s-32.3,14.3-32.3,34,14.5,34,32.3,34,32.3-14,32.3-34M948.29,334.46v-15.4c-8.8,10.7-21.9,17.3-37.5,17.3-32.6,0-57.3-26.1-57.3-61.3s25.7-61.5,58-61.5c15.2,0,28,6.7,36.8,17.1v-15h29.2v118.8h-29.2Z"/>
        <path d="M665.99,227.26s7.4-13.8,25.7-13.8c7.8,0,12.8,2.7,12.8,2.7v30.3s-11-6.8-21.1-5.4-16.5,10.6-16.5,23v70.3h-30.2v-118.7h29.2v11.6h.1Z"/>
      </g>
    </svg>`;
}

  async function getCompareAtPrice(handle, variantId) {
    const cacheKey = `compare_${handle}_${variantId}`;
    const cached = sessionStorage.getItem(cacheKey);
    if (cached) return parseFloat(cached);

    try {
      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();
      const variant = product.variants.find(v => v.id === variantId);
      if (variant?.compare_at_price) {
        sessionStorage.setItem(cacheKey, variant.compare_at_price);
        return parseFloat(variant.compare_at_price);
      }
    } catch (err) {
      console.warn('compare_at fetch fail for', handle);
    }
    return null;
  }

  function getCartDiscountBreakdown(cart) {
    const map = new Map();

    (cart.items || []).forEach(item => {
      (item.discount_allocations || []).forEach(da => {
        const title = da?.discount_application?.title || da?.title || 'Discount';
        const amt = toCents(da?.amount);
        map.set(title, (map.get(title) || 0) + amt);
      });
    });

    (cart.cart_level_discount_applications || []).forEach(app => {
      const title = app.title || 'Discount';
      const amt = toCents(app.total_allocated_amount);
      map.set(title, (map.get(title) || 0) + amt);
    });

    return Array.from(map, ([title, amount]) => ({ title, amount }));
  }

  /* -------------------------
     PREMIUM PROTECTION LOGIC
  -------------------------- */
  async function addPremiumProtection() {
    try {
      const res = await fetch(`/products/${PREMIUM_HANDLE}.js`);
      const product = await res.json();
      const variantId = product.variants[0].id;
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      const alreadyInCart = cart.items.some(i => i.handle === PREMIUM_HANDLE);
      if (alreadyInCart) return;
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
    } catch (err) {
      console.error('Error adding protection:', err);
    }
  }

  async function removePremiumProtection() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const protectionItem = cart.items.find(i => i.handle === PREMIUM_HANDLE);
      if (!protectionItem) return;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: protectionItem.key, quantity: 0 })
      });
    } catch (err) {
      console.error('Error removing protection:', err);
    }
  }

  /* -------------------------
     CART DRAWER TOGGLE
  -------------------------- */
  function toggleCartDrawer(show) {
    const overlay = document.getElementById('CustomCartDrawerOverlay');
    if (show) {
      drawer.classList.add('active');
      overlay.classList.add('active');
      setTimeout(loadCartDrawer, 150);
    } else {
      drawer.classList.remove('active');
      overlay.classList.remove('active');
    }
  }

  document.getElementById('CustomCartDrawerOverlay')
    .addEventListener('click', () => toggleCartDrawer(false));
  closeBtn?.addEventListener('click', () => toggleCartDrawer(false));

  function updateAllCartBubbles(itemCount) {
    document.querySelectorAll('.site-header__cart-bubble').forEach(bubble => {
      bubble.classList.toggle('site-header__cart-bubble--visible', itemCount > 0);
    });
  }

  async function syncCartBubbles() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    updateAllCartBubbles(cart.item_count);
  }

  /* -------------------------
     LOAD CART DRAWER
  -------------------------- */
async function loadCartDrawer() {
  const res = await fetch('/cart.js');
  const cart = await res.json();

  const drawerItems = document.getElementById('CustomCartDrawerItems');
  const drawerSubtotal = document.getElementById('CustomCartDrawerSubtotal');
  const protectionSection = document.getElementById('PremiumProtectionSection');
  const continueBtn = document.getElementById('CartDrawerContinue');
  if (!drawerItems || !drawerSubtotal) return;

  drawerItems.innerHTML = '';

  const visibleItems = cart.items.filter(i => i.handle !== PREMIUM_HANDLE);

  if (visibleItems.length === 0) {
    drawerItems.innerHTML = '<p>Your cart is empty.</p>';
    drawerSubtotal.innerHTML = `
      <div class="subtotal-line"><span>Subtotal</span><span>${money(0, cart)}</span></div>
      <div class="shipping-line"><span>Shipping</span><span>FREE</span></div>`;
    updateAllCartBubbles(0);
    if (protectionSection) protectionSection.style.display = 'none';
    return;
  }

  updateAllCartBubbles(cart.item_count);

  let compareSubtotal = 0;
  let saleSubtotal = 0;
  let trueSubtotal = 0;

  const META_DESCRIPTIONS = {
    'travel-parallettes': 'Compact and lightweight',
    'the-big-bar-plus': 'Multi-height pull-up bar',
    'the-basebar-flip': 'Dual height pull-up bar',
    'the-basebar-pro': 'Dual height pull-up bar',
    'b-bars': 'Dual height parallel bars',
    'baseblocks-air': 'The all-in-one machine (Mini Bench included)',
    'the-nordic-plus': 'Nordic curl and back extension bench',
    'the-big-bar': 'Full-size pull-up bar',
    'the-big-bar-pro': 'Pull-up and dip station',
    'basebar': 'Dual height pull-up bar',
    'the-basebench': 'Lower body bench',
    'basebench-pro': 'Lower body bench',
    'the-baseblocks-trainer': 'Calisthenics canes',
    'the-mini-bars': 'Modular parallettes',
    'the-mini-bars-deluxe': 'Modular parallettes',
    'b-bars-pro': 'Dual height parallel bars',
    'the-ring-rack': '(rings and straps included)',
    'the-wall-bars': 'Freestanding wall bars',
    'the-split-bars': 'Pull-up and dip station',
    'strongblocks': 'Hybrid parallettes and yoga blocks',
    'the-quick-rings': 'Carabiner-style gymnastics rings',
    'basebands-set': '(three pieces)',
    'the-weight-belt': 'Premium dip and pull-up belt',
    'the-compact-rack': 'Our secret squat rack',
    'the-minimalist-rings': 'Add-on for Big Bar Plus and Split Bars',
    'the-rings-1': 'Limited edition',
    'the-mini-bench': 'Freestanding bench',
    'the-weight-vest-20kg': 'Make any exercise harder'
  };

  /* -------------------------
     RENDER CART ITEMS (UNCHANGED)
  -------------------------- */
  for (const item of visibleItems) {
    const compareAt = await getCompareAtPrice(item.handle, item.variant_id);
    const currentPrice = item.final_price || item.price;
    const metaText = META_DESCRIPTIONS[item.handle?.toLowerCase()] || '';

    drawerItems.innerHTML += `
    <div class="custom-cart-drawer__item" data-key="${item.key}">
      <img src="${item.image}" alt="${item.product_title}" class="custom-cart-drawer__item-image">
      <div class="custom-cart-drawer__item-details">
        <div class="custom-cart-drawer__info">
          <div>
            <p class="custom-cart-drawer__item-title">${item.product_title}</p>
            ${item.variant_title ? `<p class="custom-cart-drawer__item-variant">${item.variant_title}</p>` : ''}
            ${metaText ? `<span class="metaline">${metaText}</span>` : ''}
          </div>

          <div class="custom-cart-drawer__item-price">
            <span class="discounted-price">${money(currentPrice, cart)}</span>

            <div class="custom-cart-drawer__qty-control">
              <button class="qty-btn minus" data-key="${item.key}">−</button>
              <span class="qty-number">${item.quantity}</span>
              <button class="qty-btn plus" data-key="${item.key}">+</button>
            </div>
          </div>
        </div>
      </div>
    </div>`;
  }

  /* -------------------------
     UPSSELL LOGIC
  -------------------------- */
const UPSELL_RULES = [
  { triggers: ['basebar'], upsell: 'basebands-set', desc: '(three pieces)' },
  { triggers: ['the-basebar-flip'], upsell: 'basebands-set', desc: '(three pieces)' },
  { triggers: ['the-basebar-pro'], upsell: 'basebands-set', desc: '(three pieces)' },

  { triggers: ['the-mini-bars'], upsell: 'the-weight-vest-20kg', desc: 'Make any exercise harder ' },
  { triggers: ['the-mini-bars-deluxe'], upsell: 'the-weight-vest-20kg', desc: 'Make any exercise harder ' },

  { triggers: ['b-bars'], upsell: 'basebands-set', desc: '(three pieces)' },
  { triggers: ['b-bars-pro'], upsell: 'the-weight-vest-20kg', desc: 'Make any exercise harder ' },
  
  { triggers: ['the-split-bars'], upsell: 'the-minimalist-rings', desc: 'Add-on for the Big Bar Plus and Split Bars ' },

  { triggers: ['the-big-bar-pro'], upsell: 'the-rings-1', desc: 'Limited edition' },
  { triggers: ['the-big-bar'], upsell: 'basebands-set', desc: '(three pieces)' },

  { triggers: ['the-big-bar-plus'], upsell: 'the-minimalist-rings', desc: 'Add-on for the Big Bar Plus and Split Bars ' },

  { triggers: ['the-ring-rack'], upsell: 'the-weight-belt', desc: 'Premium dip and pull-up belt' },

  { triggers: ['the-basebench'], upsell: 'basebands-set', desc: '(three pieces)' },
  { triggers: ['basebench-pro'], upsell: 'basebands-set', desc: '(three pieces)' },
  { triggers: ['the-nordic-plus'], upsell: 'basebands-set', desc: '(three pieces)' },

  { triggers: ['the-baseblocks-trainer'], upsell: 'the-weight-vest-20kg', desc: 'Make any exercise harder ' },

  { triggers: ['the-wall-bars'], upsell: 'basebands-set', desc: '(three pieces)' }
];
  let matchedUpsell = null;

  for (const rule of UPSELL_RULES) {
    const hasTrigger = visibleItems.some(item =>
      rule.triggers.includes(item.handle)
    );

    const alreadyInCart = visibleItems.some(item =>
      item.handle === rule.upsell
    );

    if (hasTrigger && !alreadyInCart) {
      matchedUpsell = rule;
    }
  }

  /* -------------------------
     RENDER UPSELL (SAFE)
  -------------------------- */
  if (matchedUpsell) {
    try {
      const res = await fetch(`/products/${matchedUpsell.upsell}.js`);
      const product = await res.json();

      const variantId = product.variants[0].id;
      const price = money(product.variants[0].price, cart);

      drawerItems.innerHTML += `
  <div class="cart-upsell">
    <div class="cart-upsell__inner">

      <img src="${product.images[0]}" class="cart-upsell__image">

      <div class="cart-upsell__content">
        <div class="title__line">
          <p class="cart-upsell__title">${product.title}</p>
          <p class="cart-upsell__price">${price}</p>
        </div>
        <p class="cart-upsell__desc">${matchedUpsell.desc}</p>

        <button class="cart-upsell__btn" data-variant="${variantId}">
          ADD TO CART
        </button>
      </div>

    </div>
  </div>
`;
    } catch (err) {
      console.error('Upsell load failed', err);
    }
  }

  /* -------------------------
     SUBTOTAL
  -------------------------- */
const subtotal = cart.total_price;
const afterpayAmount = Math.ceil(subtotal / 4);

drawerSubtotal.innerHTML = `
  <div class="total-line">
    <strong>Subtotal</strong>
    <strong>${money(subtotal, cart)}</strong>
  </div>

  <div class="afterpay-line">
    <div class="afterpay-left">
      <span class="afterpay-or">OR</span>
      ${afterpayLogoSvg()}
    </div>

    <div class="afterpay-right">
      4 x <strong>${money(afterpayAmount, cart)}</strong>
    </div>
  </div>

  <div class="shipping-line">
    <span>Shipping</span>
    <span>FREE</span>
  </div>`;
  attachQtyListeners();

  /* -------------------------
     UPSELL ADD TO CART
  -------------------------- */
  document.querySelectorAll('.cart-upsell__btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const variantId = btn.dataset.variant;

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      await loadCartDrawer();
      syncCartBubbles();
    });
  });

  renderPremiumProtection(cart);
  continueBtn?.addEventListener('click', () => toggleCartDrawer(false));
}



  /* -------------------------
     QUANTITY BUTTONS
  -------------------------- */
  function attachQtyListeners() {
    document.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', async e => {
        const key = e.currentTarget.dataset.key;
        const isPlus = e.currentTarget.classList.contains('plus');
        const res = await fetch('/cart.js');
        const cart = await res.json();
        const item = cart.items.find(i => i.key === key);
        if (!item) return;
        const newQty = isPlus ? item.quantity + 1 : item.quantity - 1;
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        });
        loadCartDrawer();
        syncCartBubbles();
      });
    });
  }

  /* -------------------------
     PREMIUM PROTECTION UI
  -------------------------- */
  function renderPremiumProtection(cart) {
    const container = document.getElementById('PremiumProtectionSection');
    if (!container) return;
    const hasOtherItems = cart.items.some(i => i.handle !== PREMIUM_HANDLE);
    const hasProtection = cart.items.some(i => i.handle === PREMIUM_HANDLE);
    container.style.display = hasOtherItems ? 'block' : 'none';
    container.innerHTML = `
      <div class="premium-protection">
        <div class="premium-protection__header">
          <span class="premium-protection__title">Premium Package Protection</span>
          <label class="premium-protection__switch">
            <input type="checkbox" id="premiumProtectionToggle" ${hasProtection ? 'checked' : ''}>
            <span class="slider"></span>
          </label>
        </div>
        <p class="premium-protection__text">
          For ${money(725, cart)}, we protect your delivery in the event it is damaged, stolen, or lost during transit.
        </p>
      </div>`;
    const toggle = document.getElementById('premiumProtectionToggle');
    toggle?.addEventListener('change', async e => {
      if (e.target.checked) await addPremiumProtection();
      else await removePremiumProtection();
      loadCartDrawer();
    });
  }

  /* -------------------------
     ADD TO CART INTERCEPT
  -------------------------- */
  document.querySelectorAll('form.product-form').forEach(form => {
    const addBtn = form.querySelector('.product__add-to-cart-button');
    addBtn?.addEventListener('click', async e => {
  e.preventDefault();
  e.stopImmediatePropagation();

  const formData = new FormData(form);
  await fetch('/cart/add.js', { method: 'POST', body: formData });

  // Add mini bench IF baseblocks-air was just added
  await handleMiniBenchBundle();

  toggleCartDrawer(true);
  syncCartBubbles();
  autoApplyDiscount();
}, true);
  });

  document.addEventListener('click', e => {
    const target = e.target.closest('.site-header__cart.ajax-cart__toggle');
    if (!target) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    toggleCartDrawer(true);
  }, true);

  syncCartBubbles();
});

async function handleMiniBenchBundle() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const hasBaseblocksAir = cart.items.some(i => i.handle === 'baseblocks-air123');
    const hasMiniBench = cart.items.some(i => i.handle === 'the-mini-bench123');
    const hasMiniBenchDiscount = (cart.discount_codes || []).some(dc =>
      (dc.code || '').toLowerCase() === 'minibench' && dc.applied !== false
    );

    const hasPremiumProtection = cart.items.some(i => i.handle === 'premium-delivery-protection');

    /* ----------------------------------------------
       1. AUTO-ADD PREMIUM PROTECTION ON FIRST ITEM
    if (cart.item_count == 1 && !hasPremiumProtection) {
      try {
        const prodRes = await fetch('/products/premium-delivery-protection.js');
        const product = await prodRes.json();
        const variantId = product.variants[0].id;

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
      } catch (err) {
        console.error("Error auto-adding premium protection:", err);
      }
    }
    ----------------------------------------------- */

    /* ----------------------------------------------
       2. ADD MINI BENCH IF BASEBLOCKS AIR IS IN CART
    ----------------------------------------------- */
    if (hasBaseblocksAir && !hasMiniBench) {
      try {
        const prodRes = await fetch(`/products/the-mini-bench.js`);
        const product = await prodRes.json();
        const variantId = product.variants[0].id;

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
      } catch (err) {
        console.error("Error adding Mini Bench:", err);
      }
    }

    /* ----------------------------------------------
       3. APPLY THE DISCOUNT SILENTLY (NO REDIRECT)
    ----------------------------------------------- */
    if (hasBaseblocksAir && !hasMiniBenchDiscount) {
      try {
        await fetch('/discount/minibench', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        });

        // Update drawer instantly
        await loadCartDrawer();
        syncCartBubbles();

        return "discount_applied";
      } catch (err) {
        console.error("Failed to apply Mini Bench discount:", err);
      }
    }

    return "done";

  } catch (err) {
    console.error("Error in handleMiniBenchBundle():", err);
  }
}
